//============================================================================
// Name        : index.ts
// Purpose     : Define store reducers
// Created     : 2019-08-09
// Author      : Senitron Team
// Copyright   : Copyright 2019 Senitron Corporation. All rights reserved.
//============================================================================

import { combineReducers } from "redux";
import editScheduleReducer from "./editScheduleReducer";
import scheduleReducer from "./scheduleReducer";

export default combineReducers({
    schedule: scheduleReducer,
    editSchedule: editScheduleReducer
});
